import {cssTheme} from '@yandex-delivery/blocks/theme'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const addressesContainer = css`
  max-height: ${spacing(28)}; // 224px;
  overflow-y: auto;
`

export const pointAddress = css`
  inline-size: calc(100% - ${spacing(7)});
`

export const footer = css`
  box-shadow: ${cssTheme.shadows.topNormal};
  margin-block-start: ${spacing(2)} !important;
  padding-block-start: ${spacing(1)};
`

export const image = css`
  padding: ${spacing(1)};
`

export const truncatedText = css`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
